
import axios from 'axios';
import serverLog from '@/api/serverLog';

/**
 * Autentica al usuario con las credenciales de Firmatech.
 * @param {string} user - El username.
 * @param {string} password - El password.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de autenticación.
 */
export async function authFirmatech(user, password) {
    const requestData = { user, password };

    serverLog.trace(`requestData para authFirmatech ${user} password ********`);

    const response = await axios.post(
        `/auth/login`,
        requestData
    );

    return response;
}

/**
 * Intercambia los tokens de acceso.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de intercambio de tokens.
 */
export async function exchangeTokens() {
    console.log("vamos a canjear un nuevo access token");

    const header = { Authorization: "Bearer " + sessionStorage.getItem("refresh_token") };
    const configuration = { headers: header };

    const response = await axios.post(
        `/auth/refresh-token`,
        null,
        configuration
    );

    return response;
}